import { Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IObservation } from './interface/IObservation';
import { IBuilding } from './interface/IBuilding';
import { IInstallation } from './interface/IInstallation';
import { IVerification } from './interface/IVerification';
import { ILevel } from './interface/ILevel';
import { IRefTheme } from './interface/IRefTheme';
import { IRefChapterRubric } from './interface/IRefChapterRubric';
import { IRefObservation } from './interface/IRefObservation';

@Entity('observation')
export class Observation extends BaseEntity implements IObservation{
  apiMapping = {
    id: 'extId',
    number: 'number',
    name: 'name',
    chapterShortName: 'chapterShortName',
    chapterLongName: 'chapterLongName',
    rubricShortName: 'rubricShortName',
    rubricLongName: 'rubricLongName',
    area: 'area',
    description: 'description',
    recommendations: 'recommendations',
    themeName: 'refThemeName',
    priority: 'priority',
    pictureName: 'pictureName',
    pictureData: {
      type: 'Photo',
      fieldName: 'pictureData'
    },
    nvReason: 'nvReason',    // Motivation de l'avis NV
    isNew: 'isNew',
    isChecked: 'isChecked',
    isDeleted: 'isDeleted',
    createdDate: 'createdDate',
    updatedDate: 'updatedDate',
    refObservationId: {
      fieldName: 'refObservation',
      type: 'RefObservation'
    },
    refChapterId: {
      fieldName: 'refChapter',
      type: 'RefChapterRubric'
    },
    refRubricId: {
      fieldName: 'refRubric',
      type: 'RefChapterRubric'
    },
    refThemeId: {
      fieldName: 'refTheme',
      type: 'RefTheme'
    },
    levels: {
      fieldName: 'levels',
      type: 'Level',
      map: false,
      mapType: 'many',
      mark: 'obs_ele'
    },
    installations: {
      fieldName: 'installations',
      type: 'Installation',
      map: false,
      mapType: 'many',
      mark: 'obs_ele'
    },
    equipment: 'equipment',
    technicalId: 'technicalId'
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column({ nullable: true })
  @Index()
  extId: number;

  @Column({ nullable: true })
  technicalId: string;

  @Column({ nullable: true })
  number: number;

  @Column({ nullable: true })
  name: string;

  @Column({ nullable: true })
  chapterShortName: string;

  @Column({ nullable: true })
  chapterLongName: string;

  @Column({ nullable: true })
  rubricShortName: string;

  @Column({ nullable: true })
  rubricLongName: string;

  // @Column({ nullable: true })
  // localObservation: number;

  @Column({ nullable: true })
  area: string;      // local

  @Column({ nullable: true })
  description: string;

  @Column({ nullable: true })
  recommendations: string;

  @Column({ nullable: true })
  refThemeName: string;

  @Column({ nullable: true })
  priority: number;

  @Column({ nullable: true })
  pictureName: string;

  @Column({ nullable: true, select: false })
  pictureData: string;

  @Column({ nullable: true })
  nvReason: string;    // Motivation de l'avis NV

  @Column({ nullable: true })
  isNew: boolean;

  @Column({ nullable: true })
  isChecked: boolean;

  @Column({ nullable: true })
  isDeleted: boolean;

  @Column({ nullable: true })
  createdDate: string;

  @Column({ nullable: true })
  updatedDate: string;

  @Column({ nullable: true })
  equipment: string;

  @ManyToOne('Building')
  building: IBuilding;

  @ManyToMany('Installation', 'observations')
  @JoinTable()
  installations: IInstallation[];

  @ManyToOne('Verification', 'observations')
  @JoinColumn()
  verification: IVerification;

  @ManyToMany('Level', 'observations')
  @JoinTable()
  levels: ILevel[];

  @ManyToOne('RefTheme')
  refTheme: IRefTheme;

  @ManyToOne('RefChapterRubric')
  refRubric: IRefChapterRubric;

  @ManyToOne('RefObservation')
  refObservation: IRefObservation;

  @ManyToOne('RefChapterRubric')
  refChapter: IRefChapterRubric;
}
